const showExcept = (indexToShow, fields) => {
  fields.forEach((item, index) => {
    if (index !== indexToShow) {
      item.hide();
    } else {
      item.show();
    }
  });
};

const hideAll = (fields) => {
  fields.forEach((item) => item.hide());
};

const showIfPresent = (element) => {
  if (element) {
    $(element).show();
  }
};

export { showExcept, showIfPresent, hideAll };
